import { useEffect, useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";

export const StatusBar = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Actualizar cada minuto
    
    return () => clearInterval(interval);
  }, []);

  const rawDate = format(currentTime, "EEEE, d 'de' MMMM", { locale: es });
  const formattedDate = rawDate.charAt(0).toUpperCase() + rawDate.slice(1);
  const formattedTime = format(currentTime, "HH:mm");

  return (
    <div className="status-bar">
      <div className="status-date">{formattedDate}</div>
      <div className="status-time">{formattedTime}</div>
    </div>
  );
};
